export function PatternStrips() {
  let _stripEls;
  let _strips = [];

  const init = () => {
    _selectStrips();
    _updateStrips();
    _addListeners();
  };

  const _selectStrips = () => {
    _stripEls = document.querySelectorAll('.section-pattern-strip');

    _stripEls.forEach((el, i) => {
      const holder = el.querySelector('.section-pattern-strip__holder');

      _strips[i] = {};
      _strips[i].parent = el;
      _strips[i].holder = holder;
    });
  };

  const _addListeners = () => {
    if (_stripEls.length) {
      window.addEventListener('scroll', (e) => {
        _updateStrips();
      });
    }
  };

  const _updateStrips = () => {
    _strips.forEach((el, i) => {
      if (_isInViewport(el.holder)) {
        el.parent.style.zIndex = -99999;
      } else {
        el.parent.style.zIndex = -100000;
      }
    });
  };

  const _isInViewport = (el) => {
    const offset = 100;
    const rect = el.getBoundingClientRect();
    const html = document.documentElement;

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight + offset || html.clientHeight + offset) &&
      rect.right <= (window.innerWidth || html.clientWidth)
    );
  };

  return { init };
}
